import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

const getSearch = nullBind(getAnyOrNull, 'location.search');

const fromPropsToQueryString = props => {
  const search = getSearch(props);
  return search ? new URLSearchParams(search).toString() : '';
};

// noinspection JSUnusedGlobalSymbols
export default fromPropsToQueryString;
